// extracted by mini-css-extract-plugin
export default {"post_container":"Post_post_container__4FS3R","tags":"Post_tags__7kyfC","body":"Post_body__lDng3"};